import React from 'react';
import VaccineCatalogManager from '../vaccines/VaccineCatalogManager';

export default function HeadDoctorVaccinesPage() {
  return <VaccineCatalogManager />;
}
